import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApplicationDetailsThunk } from '../store/applicationDetails.thunk';
import { clearApplicationDetails } from '../store/applicationDetails.slice';

export default function useApplicationDetails(applicationId: string | undefined) {
  const dispatch: any = useDispatch();

  const { data, loading, error } = useSelector((state: any) => state.applicationDetails);

  useEffect(() => {
    if (applicationId) {
      dispatch(fetchApplicationDetailsThunk(applicationId));
    }

    return () => {
      dispatch(clearApplicationDetails());
    };
  }, [applicationId, dispatch]);

  return { application: data, loading, error };
}